import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getResidenceTypeList = createAsyncThunk(
  "residenceTypeList/getResidenceTypeList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/residence_type/get_all_data`,

        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        data
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const residenceTypeSlice = createSlice({
  name: "residenceTypeList",
  initialState: {
    loading: false,
    residenceTypeData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getResidenceTypeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getResidenceTypeList.fulfilled, (state, action) => {
        state.loading = false;
        state.residenceTypeData = action.payload;
      })
      .addCase(getResidenceTypeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default residenceTypeSlice.reducer;
